import type {
  IAbuseReport,
  IBestTeam,
  ICommentReport,
  ICommunityReport,
  ICompanyProgress,
  IEmployeeGiftReport,
  IEmployeeProgress,
  IEngagementReport,
  IInternalTiesReport,
  IObjectiveProgress,
  IPerformanceReportCards,
  IRewardReport,
  IWeeklyItemReport,
} from '@/types/Data'
import type {
  IDateRange,
  IGetAbuseReport,
  IGetCommentReport,
  IGetCommunityReport,
  IGetCompanyProgress,
  IGetEmployeeGiftReport,
  IGetEngagementReport,
  IGetInternalTiesReport,
  IGetObjectiveProgress,
  IGetPerformanceBestTeam,
  IGetPerformanceEmployeeSuccess,
  IGetPerformanceReportCards,
  IGetPerformanceWeeklyItemReport,
  IGetRewardReport,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class ReportServices extends BaseService {
  GetCommunityReport(data: IGetCommunityReport) {
    return this.POST<ICommunityReport[]>(this.PATHS.GET_COMMUNITY_REPORT, data)
  }

  GetCommunityReportExcel(data: IGetCommunityReport) {
    return this.EXCEL(this.PATHS.GET_COMMUNITY_REPORT_EXCEL, true, data)
  }

  GetEmployeeRewardReport(data: IGetRewardReport) {
    return this.POST<IRewardReport[]>(this.PATHS.GET_EMPLOYEE_REWARD_REPORT, data)
  }

  GetEmployeeRewardReportExcel(data: IDateRange) {
    return this.EXCEL(this.PATHS.GET_EMPLOYEE_REWARD_REPORT_EXCEL, false, data)
  }

  GetEmployeeGiftReport(data: IGetEmployeeGiftReport) {
    return this.POST<IEmployeeGiftReport[]>(this.PATHS.GET_EMPLOYEE_GIFT_REPORT, data)
  }

  GetEmployeeGiftReportExcel(data: IDateRange) {
    return this.EXCEL(this.PATHS.GET_EMPLOYEE_GIFT_REPORT_EXCEL, false, data)
  }

  GetPostReportByDivision(data: IGetInternalTiesReport) {
    return this.POST<IInternalTiesReport[]>(this.PATHS.GET_POST_REPORT_BY_DIVISION, data)
  }

  GetPostReportByDivisionExcel(data: IGetInternalTiesReport) {
    return this.EXCEL(this.PATHS.GET_POST_REPORT_BY_DIVISION_EXCEL, true, data)
  }

  GetAbuseReport(data: IGetAbuseReport) {
    return this.POST<IAbuseReport[]>(this.PATHS.GET_ABUSE_REPORT, data)
  }

  GetAbuseReportExcel(data: IGetAbuseReport) {
    return this.EXCEL(this.PATHS.GET_ABUSE_REPORT_EXCEL, true, data)
  }

  GetEngagementReport(data: IGetEngagementReport) {
    return this.POST<IEngagementReport[]>(this.PATHS.GET_ENGAGEMENT_REPORT, data)
  }

  GetEngagementReportExcel(data: IGetEngagementReport) {
    return this.EXCEL(this.PATHS.GET_ENGAGEMENT_REPORT_EXCEL, true, data)
  }

  GetCommentReport(data: IGetCommentReport) {
    return this.POST<ICommentReport[]>(this.PATHS.GET_COMMENT_REPORT, data)
  }

  GetCommentReportExcel(data: IGetCommentReport) {
    return this.EXCEL(this.PATHS.GET_COMMENT_REPORT_EXCEL, true, data)
  }

  // #region Performance Reports
  GetPerformanceBestTeam(data: IGetPerformanceBestTeam) {
    return this.GET<IBestTeam[]>(this.PATHS.GET_PERFORMANCE_BEST_TEAM, { ...data })
  }

  GetPerformanceBestTeamExcel(data: IGetPerformanceBestTeam) {
    return this.EXCEL(this.PATHS.GET_PERFORMANCE_BEST_TEAM_EXCEL, false, { ...data })
  }

  GetPerformanceEmployeeSuccess(data: IGetPerformanceEmployeeSuccess) {
    return this.GET<IEmployeeProgress[]>(this.PATHS.GET_PERFORMANCE_EMPLOYEE_SUCCESS, { ...data })
  }

  GetPerformanceEmployeeSuccessExcel(data: IGetPerformanceEmployeeSuccess) {
    return this.EXCEL(this.PATHS.GET_PERFORMANCE_EMPLOYEE_SUCCESS_EXCEL, false, { ...data })
  }

  GetPerformanceCompanyProgress(data: IGetCompanyProgress) {
    return this.GET<ICompanyProgress>(this.PATHS.GET_PERFORMANCE_COMPANY_PROGRESS, { ...data })
  }

  GetPerformanceObjectiveProgress(data: IGetObjectiveProgress) {
    return this.GET<IObjectiveProgress[]>(this.PATHS.GET_PERFORMANCE_OBJECTIVE_PROGRESS, {
      ...data,
    })
  }

  GetPerformanceWeeklyItemReport(data: IGetPerformanceWeeklyItemReport) {
    return this.GET<IWeeklyItemReport[]>(this.PATHS.GET_PERFORMANCE_WEEKLY_ITEM_REPORT, { ...data })
  }

  GetPerformanceCards(data: IGetPerformanceReportCards) {
    return this.GET<IPerformanceReportCards>(this.PATHS.GET_PERFORMANCE_CARDS, { ...data })
  }
  // #endregion
}
